import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import useAuth from "../../hooks/useAuth";
import Loader from "../../components/Loader";
import { BASE_URL } from "../../utils/Element";
import Modal from "../../components/Modal/Modal";
import AddAcquisitionData from "./components/AddAcquisitionData";

const initialData = {
  minPrice: "",
  maxPrice: "",
  minAskingCapRate: "",
  minLeaseTermRemaining: "",
  updateDate: "",
  comment: "",
  contactId: "",
  contactName: "",
  state: [],
  propertyType: [],
  landlordType: [],
  tenantName: [],
  availabilityStatus: [],
  buyerStatus: "",
  min_traffic_count: {
    oneMile: "",
    secondMile: "",
    thirdMile: "",
  },
  min_demographics: {
    oneMile: "",
    secondMile: "",
    thirdMile: "",
  },
  price_sf:"",
  rent_sf:"",
  total_gla:"",
};

const EditBuyersModal = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const [acquisitionData, setAcquisitionsData] = useState(initialData);

  const handleClose = () => {
    onClose();
    setError();
    setAcquisitionsData(initialData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      property_type_ids: acquisitionData?.propertyType,
      min_price: acquisitionData?.minPrice,
      max_price: acquisitionData?.maxPrice,
      min_traffic_count: acquisitionData?.min_traffic_count,
      min_demographics: acquisitionData?.min_demographics,
      price_sf: acquisitionData?.price_sf,
      rent_sf: acquisitionData?.rent_sf,
      total_gla: acquisitionData?.total_gla,
      min_asking_cap_rate: acquisitionData?.minAskingCapRate,
      min_lease_term_reamaining: acquisitionData?.minLeaseTermRemaining,
      landlord_responsibilities: acquisitionData?.landlordType,
      tenant_name: acquisitionData.tenantName,
      state: acquisitionData.state,
      criteria_update_date: acquisitionData.updateDate,
      comment: acquisitionData.comment,
      contact_id: acquisitionData.contactId,
      availability_status: acquisitionData?.availabilityStatus,
      buyer_status: acquisitionData?.buyerStatus === "Pipeline" ? 0 : acquisitionData?.buyerStatus,
    };

    if (Number(acquisitionData?.maxPrice) < Number(acquisitionData?.minPrice)) {
      setError({ ...error, max_price: "Max price should be greater than min price" });
    } else {
      axios
        .post(`${BASE_URL}/acquisition-edit/${id}`, dataToSend, config)
        .then((res) => {
          handleClose();
          onCallApi();
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        })
        .catch((err) => {
          setError(err.response.data.errors);
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    }
  };

  const fetchDetails = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/acquisition-getbyid/${id}`, config)
      .then((res) => {
        const buyerData = res?.data?.data;
        setAcquisitionsData({
          minPrice: buyerData?.min_price,
          maxPrice: buyerData?.max_price,
          minAskingCapRate: buyerData?.min_asking_cap_rate,
          min_traffic_count: buyerData?.min_traffic_count,
          min_demographics: buyerData?.min_demographics,
          price_sf: buyerData?.price_sf,
          rent_sf: buyerData?.rent_sf,
          total_gla: buyerData?.total_gla,
          minLeaseTermRemaining: buyerData?.min_lease_term_reamaining,
          tenantName: buyerData?.tenant_details?.map((el) => el?.id),
          updateDate: buyerData?.criteria_update_date,
          comment: buyerData?.comment,
          contactId: buyerData?.contact_id,
          contactName: `${buyerData?.contact?.first_name} ${buyerData?.contact?.last_name}`,
          state: buyerData?.state,
          propertyType: buyerData?.property_type?.map((el) => el?.id),
          landlordType: buyerData?.landlord_responsibilities?.map((el) => el?.replace(/\s+/g, "")),
          availabilityStatus: buyerData?.availability_status,
          // availabilityStatus: buyerData?.availability_status === 0 ? "Off Market" : "On Market",
          buyerStatus: buyerData?.buyer_status === 0 ? "Pipeline" : buyerData?.buyerStatus,
        });
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (id && showModal) {
      fetchDetails();
    }
  }, [id, showModal]);

  return (
    <Modal title="Edit Acquisition Criteria" desc="Edit the Acquisition Criteria information." show={showModal} onClose={handleClose}>
      {loading ? (
        <Loader />
      ) : (
        <AddAcquisitionData
          from={"buyers"}
          error={error}
          acquisitionData={acquisitionData}
          onSetAcquisitionsData={(value) => {
            setAcquisitionsData(value);
          }}
          onSetError={(value) => setError(value)}
          onClose={handleClose}
          handleSubmit={handleSubmit}
          showModal={showModal}
          type="Edit"
        />
      )}
    </Modal>
  );
};

export default EditBuyersModal;
